module.exports = __webpack_public_path__ + "static/img/spread1-2.22dfba9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/spread1-2.jpg
// module id = H8Ch
// module chunks = 1